import TextTitleCondensed from 'components/TextTitleCondensed'
import React from 'react'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import getNameByIdWorkoutSelector from 'modules/workout/redux/selectors/get-name-by-id/index.js'
import WorkoutArrowDownIcon from 'pages/Workout/components/Workout/components/ArrowDownIcon/index.js'
import Row from 'components/Row.js'
import WorkoutNameWrapper from 'pages/Workout/components/Workout/components/NameWrapper/index.js'

/**
 * @param props
 * @param props.id
 * @param props.onClickName
 * @param props.isAboutVisible
 * @returns {JSX.Element}
 * @constructor
 */
export default function WorkoutNameText (props) {
  const {
    id,
    isAboutVisible
  } = props
  const name = useSelector(getNameByIdWorkoutSelector(id))
  return (
    <WorkoutNameWrapper {...props}>
      <Row ac>
        <TextTitleCondensed
          mr
          numberOfLines={1}
          style={{
            textTransform: 'uppercase',
            textAlign: 'left'
          }}
          c='#151D21'
        >
          {name}
        </TextTitleCondensed>

        <WorkoutArrowDownIcon
          isAboutVisible={isAboutVisible}
        />
      </Row>
    </WorkoutNameWrapper>
  )
}
